import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M16.042 14.375v-6.25c0-.92-.747-1.667-1.667-1.667h-.278a.833.833 0 0 1-.769-.512l-.614-1.475a.833.833 0 0 0-.77-.513H8.056a.833.833 0 0 0-.77.513l-.614 1.475a.833.833 0 0 1-.77.512h-.277c-.92 0-1.667.747-1.667 1.667v6.25c0 .92.747 1.667 1.667 1.667h8.75c.92 0 1.667-.747 1.667-1.667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" /> <path d="M12.708 10.833a2.708 2.708 0 1 1-5.416 0 2.708 2.708 0 0 1 5.416 0Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />' }
  })
);